import { render, staticRenderFns } from "./desc-images.vue?vue&type=template&id=58938904&"
import script from "./desc-images.vue?vue&type=script&lang=js&"
export * from "./desc-images.vue?vue&type=script&lang=js&"
import style0 from "./desc-images.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "desc-images.vue"
export default component.exports